// Email validation helpers (originally from client/utils/emailValidationHelper.ts)
const atomChar = () => {
	return '[-a-zA-Z0-9+_!"\'#$%^&*{}/=?`|~]';
};

const alpha = () => {
	return '[a-zA-Z]';
};

const alnum = () => {
	return '[a-zA-Z0-9]';
};

const alnumhy = () => {
	return '(?:[a-zA-Z0-9-])';
};

const labelIsCorrectLength = () => {
	return '(?=[^.]{1,63}(?:\\.|$))';
};

const tldLabelPattern = () => {
	return `${alpha()}{1,64}`;
};

const hostLabelPattern = () => {
	return `${labelIsCorrectLength()}${alnum()}(?:${alnumhy()}{0,61}${alnum()})?`;
};

const domainLabelPattern = () => {
	return `${hostLabelPattern()}\\.${tldLabelPattern()}`;
};

const fqdnPattern = () => {
	return `(?=.{1,255}$)(?:${hostLabelPattern()}\\.)*${domainLabelPattern()}`;
};

const domainPartPattern = () => {
	return fqdnPattern();
};

const localPartPattern = () => {
	return `${atomChar()}(?:\\.?${atomChar()}){0,63}`;
};

const strictRegexp = () => {
	return new RegExp(`^${localPartPattern()}@${domainPartPattern()}$`, 'i');
};

const regexp = () => {
	return strictRegexp();
};

export const valid = (value: string) => {
	if (value === null) return false;
	return regexp().test(value);
};

// Phone validation helper (originally from client/utils/validate.ts)
export const validate10Digits = (str = '') => {
	const justDigits = str.replace(/\D/g, '');
	return justDigits.split('').length === 10 || str.length === 0;
};
